import type {
    CreateStandaloneIDV,
    StandaloneIDVEntry,
    UpdateStandaloneIDV,
} from '@common/types/standaloneIdv';
import type { TreefortFileResponse } from '@common/types/treefort';
import axiosInstance from './axiosInstance';

export async function getAllIDVs(lawFirmIds: number[]) {
    return axiosInstance.get<StandaloneIDVEntry[]>('/api/v1/standalone-idv', {
        params: { lawFirmIds },
        paramsSerializer: {
            indexes: null,
        },
    });
}

export async function createIDV(payload: CreateStandaloneIDV) {
    return axiosInstance.post<TreefortFileResponse>('/api/v1/standalone-idv', payload);
}

export async function updateCustomFileNumber(payload: UpdateStandaloneIDV) {
    return axiosInstance.put<void>('/api/v1/standalone-idv', payload);
}

export async function deleteSaIdv(payload: string[]) {
    return axiosInstance.put<void>('/api/v1/prospects', payload);
}
